import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // берёт из .env
  headers: {
    'Content-Type': 'application/json'
  }
})

let clientIp = null

axios.get('https://api.ipify.org?format=json')
  .then(res => {
    clientIp = res.data.ip
    console.log('[CLIENT IP]', clientIp)
  })
  .catch(() => {
    console.warn('Failed to get client IP')
  })

instance.interceptors.request.use(config => {
  if (clientIp) {
    config.headers['X-Client-IP'] = clientIp
  }

  if (process.env.APP_ENV !== 'prod') {
    console.log(`[API REQUEST] ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`)
  }
  return config
})

export default instance
